<div class="typeahead__autosuggest__list" id="company_search_suggestions">
    <ul class="typeahead__suggestions__items">
        <li *ngFor="let suggestion of suggestions"
            (mouseenter)="suggestion.highlighted = true"
            (mouseleave)="suggestion.highlighted = false"
            (click)="selected.emit(suggestion)"
            class="typeahead__suggestions__item">
            <div class="typeahead__autosuggest__listItem"
                privacySensitive>
                <a [class]="'typeahead__autosuggest__link ' + suggestIcon"
                    [ngClass]="{ 'typeahead__autosuggest__cursor': suggestion.highlighted }">
                    <span [innerHTML]="suggestion.displayText | emphasizeMatches:suggestion.searchText"></span>
                </a>
            </div>
        </li>
    </ul>
</div>
